import hamburger from "../Assets/menu.png";
import manondesk from "../Assets/ManOnDesk.png";
import manfind from "../Assets/manfinding.png";
import circleShape from "../Assets/Beneficiarycircle.png";
import failed from "../Assets/failed.png";
import success from "../Assets/success.png";
import pending from "../Assets/pending.png";
import nodata from "../Assets/nodata.png";
import nobank from "../Assets/nobank.png";
import loginillustration2 from "../Assets/Login illustration (2).png";
import completeKYC from "../Assets/kycImage.png";
import pendingKYC from "../Assets/PendingKyc.webp";
import rejectedKYC from "../Assets/rejectedKYC.png";
import WebsiteLogo from "../Assets/Logo/350x 115 px.png";
import WebsiteSmallLogo from "../Assets/Logo/96 px icon.png";
import comingSoon from "../Assets/comingSoon.webp";
import dashboardBanner from "../Assets/aeps-service-provider.jpg";
import Finger from "../Assets/fingers count.jpg";
import yesBank from "../Assets/yes_bank.png";
import dummyuser from "../Assets/user (1).png";
import DMT from "../Assets/DMT.png";
import credit from "../Assets/card.png";
import aeps from "../Assets/aeps.png";
import electricitybill from "../Assets/electricitybill.png";
import recharges from "../Assets/recharges.png";
import cashDeposit from "../Assets/cashDeposit.png";
export const Images = {
  loginillustration2,
  comingSoon,
  dashboardBanner,
  yesBank,
  completeKYC,
  pendingKYC,
  rejectedKYC,
  WebsiteLogo,
  WebsiteSmallLogo,
  // broadband,
  // cable,
  circleShape,
  // club,
  // DMT,
  failed,
  success,
  pending,
  manondesk,
  manfind,
  nodata,
  nobank,
  hamburger,
  Finger,
  dummyuser,
  DMT,
  credit,
  aeps,
  electricitybill,
  recharges,
  cashDeposit,
};

import mobileRecharge from "../Assets/Services/rechargeMobile.png";
import cms from "../Assets/Services/CMS.png";
import travel from "../Assets/Services/travel.png";
import credit_report from "../Assets/Services/credit_report.png";
import insurance from "../Assets/Services/insurance.png";
import POS from "../Assets/Services/POS.png";
import utility from "../Assets/Services/utility.png";
import loansBilss from "../Assets/Services/loansBilss.png";
import indo_nepal from "../Assets/Services/indo_nepal.png";
import express_payout from "../Assets/Services/express_payout.png";
import aeps2 from "../Assets/Services/aeps2.png";
import creditCardBill from "../Assets/Services/creditCardBill.png";
import fastag from "../Assets/Services/fastag.png";
import elecbill from "../Assets/Services/elecbill.png";
export const Services = {
  mobileRecharge,
  travel,
  loansBilss,
  utility,
  POS,
  insurance,
  credit_report,
  cms,
  indo_nepal,
  express_payout,
  aeps2,
  creditCardBill,
  fastag,
  elecbill,
};
